import { XClose } from '@timelyapp/icons/line-icons';
import classNames from 'classnames';
import React from 'react';
import Button from '../Button';
import { Box } from '../box/Box';
import { Text } from '../text/Text';
import styles from './FloatingMessage.module.scss';

export interface FloatingMessageProps extends React.HTMLAttributes<HTMLDivElement> {
  onDismiss?: () => void;
  variant?: 'default' | 'success' | 'warning' | 'error' | 'info';
  /** Fixed floater to bottom/center of screen @default true. When false, absolute positioning is used */
  fixed?: boolean;
}
/**
 * Displays a floating message with an optional dismiss button.
 * @see `TicHintMessage` for an example of usage and customization
 */
export const FloatingMessage: React.FC<FloatingMessageProps> = ({
  children,
  onDismiss,
  variant = 'default',
  fixed = true,
  ...rest
}) => {
  return (
    <Box.Row
      gap="medium"
      padding="medium"
      className={classNames(styles.container, styles[`variant-${variant}`], {
        [styles.fixed]: fixed,
      })}
      justifyContent="center"
      as={Text}
      // @ts-expect-error How do we get `as` props to be accepted on `Text` here?
      size="small"
      {...rest}
    >
      {children}
      {!!onDismiss && (
        <Button onClick={onDismiss} size="xsmall" priority="low">
          <XClose />
        </Button>
      )}
    </Box.Row>
  );
};

FloatingMessage.displayName = 'FloatingMessage';
